module.exports = __webpack_public_path__ + "c72938c31f8a9cdaa549bce5e57a6c8d.png";